
$(document).ready(function() {
    
    var $footerElement = $('.footer');

    // On mobile stop the .brick__link's from linking to a page
    $('.brick__link').on('click', function(e) {
        if($footerElement.width() < 768) {
            e.preventDefault();

            var $parentElement = $(this).parent(),
                $moreInfoElement = $parentElement.find('.brick__more-info-container');

            $parentElement.toggleClass('brick--open');
            $moreInfoElement.slideToggle(300);
        }
    });

});